import React from "react";
import PropTypes from "prop-types";

import Button from "../../Habitacional/core/Button";

import { ReactComponent as WarningIcon } from "../../../assets/images/icons/warning-icon.svg";

import useWindowSize from "../../../hooks/useWindowSize";

import * as S from "../Modal/Modal.Style";

const FileMessagesModal = ({ show, onClose }) => {
  const { width } = useWindowSize();
  const isDesktop = width >= 768;

  return (
    <S.ModalResponsive show={show} onClose={onClose}>
      <header className="header">
        <h1>
          <WarningIcon /> Ops, seu arquivo está muito grande :(
        </h1>

        <p>
          Nosso limite é de até 15 MB. Para tentar reduzir, troque o formato do
          arquivo, tire uma foto ao invés de escanear ou use algum recurso que
          diminua o tamanho. Se ainda assim não conseguir, envie pelo nosso
          WhatsApp{" "}
          <a
            href="https://wa.me/5508007492020"
            target="_blank"
            rel="noreferrer"
          >
            0800 749 2020
          </a>{" "}
          ou no e-mail{" "}
          <a href="mailto:acolhimentohabitacional@caixaseguradora.com.br">
            acolhimentohabitacional@caixaseguradora.com.br
          </a>
          .
        </p>
      </header>

      <div className="divider" />

      <div className="footer">
        <Button
          variant={isDesktop ? "muted-primary" : "tertiary"}
          type="button"
          onClick={onClose}
        >
          Fechar
        </Button>
      </div>
    </S.ModalResponsive>
  );
};

FileMessagesModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
};

FileMessagesModal.defaultProps = {
  show: false,
  onClose: null,
};

export default FileMessagesModal;
